import { CSS } from '@grupoboticario/flora-react'

export const cardCss: CSS = {
  backgroundColor: '$nonInteractiveOutline',
  height: '$20',
  width: '100%',
  padding: '$4',
  borderRadius: '$medium',
  minWidth: '176px'
}

export const errorTextCss: CSS = {
  color: '$error-standard'
}

export const getDynamicColorCss = (color: string): CSS => ({
  color
})
